import { NextPage } from "next";
import { Layout } from "@kursk/components/Layout/Layout";
import React from "react";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { articlesSlice } from "@common/redux/slices/articles.slice";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { HeaderBlock } from "@kursk/components/ui/HeaderBlock/HeaderBlock";
import styles from "./SingleOverview.module.scss";
import { SocialLinks } from "@kursk/components/ui/SocialLinks/SocialLinks";
import { ContentBlock } from "@kursk/components/ui/ContentBlock/ContentBlock";
import { Tags } from "@kursk/components/ui/Tags/Tags";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { Socials } from "@kursk/components/pages/Home/Socials/Socials";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { FeedbacksBlock } from "@kursk/components/ui/FeedbacksBlock/FeedbacksBlock";

export const SingleOverview: NextPage = () => {
  const { article } = useSelectSlice(articlesSlice);
  const { overviews } = useSelectSlice(recommendationSlice);
  if (!article) {
    return <></>;
  }
  return (
    <Layout key={`overview_${article._id}`}>
      <SeoMetaTitles page="singleOverview" entity={{ name: article.name, seo: article.seo, image: article.image }}
        showOgImage={true}/>
      <section className={styles.overview_header}>
        <HeaderBlock
          entityType={'overviews'}
          entity={article}
          goBack={'/overviews'}
          goBackTitle={'вернуться к списку обзоров'}/>
      </section>
      <section className={styles.entity_share}>
        <SocialLinks/>
      </section>
      <section className={styles.entity_content}>
        <ContentBlock content={article?.content} source={article?.source}/>
      </section>
      <section className={styles.entity_tags}>
        <Tags link={'/overviews'} className={styles.tags} tags={article?.tags}/>
      </section>
      <section className={styles.entity_feedbacks}>
        <FeedbacksBlock entity={article} entityType={'overviews'}/>
      </section>
      <section className={styles.entity_recommendations}>
        <RecommendationsBlock
          entityType="overviews"
          data={overviews}
          title={'также рекомендуем'}
          goTo={'/overviews'}
          goToTitle={'все обзоры'}/>
      </section>
      <section className={styles.entity_social}>
        <Socials/>
      </section>
    </Layout>
  )
}
